let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fvkeJ")).then(() => parcelRequire('hs45I'));